import { HelmetDexteel } from "@dexteel/mesf-core";
import { NextCampaigns } from "./components/NextCampaigns";

export const NextCampaignsPage = () => {
	return (
		<>
			<HelmetDexteel title="Next Campaigns" />
			<NextCampaigns />
		</>
	);
};
